/**
 * @generated SignedSource<<f1f066e78faf4d485387c67345ec1b35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateHubspotVerificationKeyInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateHubspotVerificationKeyMutation$variables = {
  input: CreateHubspotVerificationKeyInput;
};
export type CreateHubspotVerificationKeyMutation$data = {
  readonly createHubspotVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type CreateHubspotVerificationKeyMutation = {
  variables: CreateHubspotVerificationKeyMutation$variables;
  response: CreateHubspotVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateHubspotVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createHubspotVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateHubspotVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateHubspotVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2a6c805464133d05ad052c6be973e23e",
    "id": null,
    "metadata": {},
    "name": "CreateHubspotVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation CreateHubspotVerificationKeyMutation(\n  $input: CreateHubspotVerificationKeyInput!\n) {\n  createHubspotVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "4de9c428f561e0f17f8035157b3cd5ff";

export default node;
